import { createSlice } from "@reduxjs/toolkit";

import { addPortCallNotificationData, getPortCallNotificationData } from "../thunks/portCallNotifiacationThunk";

interface PortCallsListState {
  portCalls: any[];
  portCallSuccess:any;
  loading: boolean;
  error: string | null;
};

const initialState: PortCallsListState = {
  portCalls: [],
  portCallSuccess:null,
  loading: false,
  error: null,
};

export const portCallNOtificationSlice = createSlice({
  name: "portCallsNotification",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPortCallNotificationData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPortCallNotificationData.fulfilled, (state, action) => {
        state.portCallSuccess = action.payload;
        state.loading = false;
      })
      .addCase(getPortCallNotificationData.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(addPortCallNotificationData.pending, (state) => {
        state.loading = true;
      })
      .addCase(addPortCallNotificationData.fulfilled, (state, action) => {
        state.portCalls = action.payload || [];
        state.loading = false;
      })
      .addCase(addPortCallNotificationData.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
  },
});

export default portCallNOtificationSlice.reducer;